import React, { useEffect, useState } from 'react';
import { ShieldCheck, Phone, Mail } from 'lucide-react';
import api from '@/lib/api';

/** Escalation details only — no report data is ever shown to mentors or partners. */
export const SafeguardingContactCard = ({ compact = false }) => {
  const [contact, setContact] = useState(null);

  useEffect(() => {
    api.get('/safeguarding/contact').then(r => setContact(r.data)).catch(() => setContact(null));
  }, []);

  if (!contact) return null;

  return (
    <div className={`bg-white rounded-2xl border border-[#EFF0F2] ${compact ? 'p-4' : 'p-5'}`} data-testid="safeguarding-contact-card">
      <p className="text-xs font-bold uppercase tracking-wider text-[#9CA3AF] flex items-center gap-1.5 mb-2">
        <ShieldCheck className="h-3.5 w-3.5" /> Safeguarding contact
      </p>
      <p className="text-sm font-semibold text-[#1F2937] break-words">
        {contact.contact_name || contact.school_name}
      </p>
      <div className="mt-1.5 space-y-1">
        {contact.contact_email && (
          <a href={`mailto:${contact.contact_email}`} className="text-xs text-[#4B5563] hover:text-[#F97D6A] flex items-center gap-1.5 break-all" data-testid="safeguarding-contact-email">
            <Mail className="h-3 w-3 shrink-0" /> {contact.contact_email}
          </a>
        )}
        {(contact.contact_mobile || contact.school_phone) && (
          <a href={`tel:${contact.contact_mobile || contact.school_phone}`} className="text-xs text-[#4B5563] hover:text-[#F97D6A] flex items-center gap-1.5" data-testid="safeguarding-contact-phone">
            <Phone className="h-3 w-3 shrink-0" /> {contact.contact_mobile || contact.school_phone}
          </a>
        )}
      </div>
      <p className="text-[11px] text-[#9CA3AF] mt-2.5 leading-relaxed">
        {contact.escalation}
      </p>
    </div>
  );
};

export default SafeguardingContactCard;
